export default {
  entities: null,
  notifications: {
    hasFetched: false,
    isLoading: true,
    error: {}
  },
  softpullConsent: {
    isOptedIn: false,
    hasFetched: false,
    isLoading: true,
    error: {}
  },
  updateEmailNotifications: {
    isLoading: false,
    error: {}
  },
  updateTCPANotifications: {
    isLoading: false,
    error: {}
  }
};
